/**
 * Copyright (c) 2025 Kalpit Patel
 *
 * Sole Developer and Owner:
 * Kalpit Patel is the sole developer and creator of this entire application.
 * No other individual or entity has contributed to the development of this software.
 * All rights reserved.
 *
 * This file is part of AksharJobs application.
 */

import React, { useState, useRef, useEffect } from 'react';
import '../styles/CustomTooltip.css';

const CustomTooltip = ({ text, children, position = 'top' }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });
  const tooltipRef = useRef(null);
  const wrapperRef = useRef(null);

  useEffect(() => {
    if (isVisible && tooltipRef.current && wrapperRef.current) {
      const wrapperRect = wrapperRef.current.getBoundingClientRect();
      const tooltipRect = tooltipRef.current.getBoundingClientRect();
      
      let top = 0;
      let left = 0;

      switch (position) {
        case 'top':
          top = wrapperRect.top - tooltipRect.height - 10;
          left = wrapperRect.left + (wrapperRect.width / 2) - (tooltipRect.width / 2);
          break;
        case 'bottom':
          top = wrapperRect.bottom + 10;
          left = wrapperRect.left + (wrapperRect.width / 2) - (tooltipRect.width / 2);
          break;
        case 'left':
          top = wrapperRect.top + (wrapperRect.height / 2) - (tooltipRect.height / 2);
          left = wrapperRect.left - tooltipRect.width - 10;
          break;
        case 'right':
          top = wrapperRect.top + (wrapperRect.height / 2) - (tooltipRect.height / 2);
          left = wrapperRect.right + 10;
          break;
        default:
          top = wrapperRect.top - tooltipRect.height - 10;
          left = wrapperRect.left + (wrapperRect.width / 2) - (tooltipRect.width / 2);
      }

      // Keep tooltip within viewport
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;

      if (left < 10) left = 10;
      if (left + tooltipRect.width > viewportWidth - 10) {
        left = viewportWidth - tooltipRect.width - 10;
      }
      if (top < 10) top = 10;
      if (top + tooltipRect.height > viewportHeight - 10) {
        top = viewportHeight - tooltipRect.height - 10;
      }

      setTooltipPosition({ top, left });
    }
  }, [isVisible, position]);

  return (
    <div
      ref={wrapperRef}
      className="custom-tooltip-wrapper"
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
    >
      {children}
      {isVisible && text && (
        <div
          ref={tooltipRef}
          className={`custom-tooltip custom-tooltip-${position}`}
          style={{
            top: `${tooltipPosition.top}px`,
            left: `${tooltipPosition.left}px`,
          }}
        >
          {text}
        </div>
      )}
    </div>
  );
};

export default CustomTooltip;
